import ddt from '@wix/da-ddt';
import { WriterError, WriterPopupType } from './types';
var logger = ddt.createLogger('writer.saga');
/** Handles a subset of writer errors related to media content counts */
function convertMediaContentViolationToWriterError(violation) {
    switch (violation) {
        case 'wix-draft-plugin-giphy':
            return WriterError.GifCountExceeded;
        case 'DA_COMM_EMOTE|DA_OFF_EMOTE':
            return WriterError.EmoteCountExceeded;
        case 'wix-draft-plugin-image':
            return WriterError.ImageCountExceeded;
        case 'mention':
            return WriterError.MentionCountExceeded;
        default:
            return WriterError.Unspecified;
    }
}
export function convertResponseErrorToWriterError(errorDetails) {
    var _a;
    if (errorDetails === void 0) { errorDetails = {}; }
    if (errorDetails.errorType === 'media_content_violation') {
        var violations = (_a = errorDetails.violations) !== null && _a !== void 0 ? _a : [];
        if (violations.length > 0) {
            // The UI spec doesn't cover cases for multiple violations, so we'll just take the first one
            return convertMediaContentViolationToWriterError(violations[0]);
        }
    }
    switch (errorDetails.editorRaw) {
        case 'editorRaw has incorrect length':
            return WriterError.ContentTooLong;
        default:
            break;
    }
    return WriterError.Unspecified;
}
export function getWriterEndpoint(path, type) {
    if (type === void 0) { type = WriterPopupType.JOURNAL; }
    switch (type) {
        case WriterPopupType.LITERATURE:
            return "/literature".concat(path);
        default:
            return "/journal".concat(path);
    }
}
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                journal: 'error',
            };
        }
        logger.log('faking the response!');
        var deviationsByType = require('@wix/da-sample-data').deviationsByType; // eslint-disable-line global-require
        var deviation = deviationsByType.journal[0];
        if (options.url === '/journal/create' ||
            options.url === '/journal/content/update' ||
            options.url === '/literature/create' ||
            options.url === '/literature/content/update') {
            deviation.title = options.data.title;
            deviation.publishedTime = undefined;
            deviation.textContent = {
                excerpt: options.data.editorSnippet,
                html: {
                    type: 'draft',
                    markup: options.data.editorRaw,
                    features: options.data.editorFeatures,
                },
            };
        }
        return { deviation: deviation };
    }
}
//# sourceMappingURL=utils.js.map